export default {
    namespaced: true,
    state: {
    },
    mutations: {
    },
    actions: {
        getOrdersStatus(context, params) {
            return this.$axios.get('/ordersSts', {params: params})
                .then(response => {
                    return response;
                })
        },

    },
    getters: {
    }
}
